import Component from '../core/Component'
import scrollToElement from '../services/Viewport/scrollToElement'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import { queryAll } from '../utils/dom'
import EventBus from '../core/EventBus'

export const STATES = {
    PINNED: 'is-pinned',
    ACTIVE: 'is-active',
    OFFSET: 'is-offset'
}

export default class StickyNavigation extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            inner: null,
            items: [],
            indicator: null
        }

        this.navClientRect
        this.active
        this.anchors
        this.index

        this.enquireHandler = {
            match: () => this.match(),
            unmatch: () => this.unmatch(),
        }
    }

    prepare() {
        this.ref.items.forEach((element, index) => {
            element.addEventListener('click', ::this.handleClick)
        })

        this.items = this.ref.items.filter($element => !$element.classList.contains('mobile'))

        this.anchors = queryAll('[data-rel="anchor"]')

        enquire.register(queries.largeUp, this.enquireHandler)

        setTimeout(() => {
            this.handleResize()
        }, 500)

        EventBus.on('Header:pin', ::this.handleHeaderPinned)
    }

    destroy() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.handleResize)
    }

    match = () => {
        this.handleResize()

        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('resize', this.handleResize)
    }

    unmatch = () => {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.handleResize)
        this.element.classList.remove(STATES.PINNED)
    }

    handleHeaderPinned = (event) => {
        if (event.isPinned) {
            this.element.classList.add(STATES.OFFSET)
        } else {
            this.element.classList.remove(STATES.OFFSET)
        }
    }

    handleScroll = (event) => {
        if (window.scrollY > this.navClientRect.top) {
            this.handleEnter()
        } else {
            this.handleLeave()
        }

        this.anchors.forEach((element, index) => {
            let windowCenter = window.scrollY + window.innerHeight/3 - this.navClientRect.height

            if (windowCenter > this.anchors[index].clientRect.top &&
                windowCenter < this.anchors[index].clientRect.bottom) {
                this.switchActive(index)
            }
        })
    }

    handleResize = () => {
        this.active = this.ref.inner.querySelector('.is-active').getAttribute('href').replace('#', '')
        this.index = this.ref.inner.querySelector('.is-active').getAttribute('href').replace('#', '')

        this.navClientRect = {
            top: this.ref.inner.getBoundingClientRect().top + window.scrollY,
            bottom: this.ref.inner.getBoundingClientRect().bottom + window.scrollY,
            height: this.ref.inner.getBoundingClientRect().height
        }

        this.anchors.forEach((element, index) => {
            this.anchors[index].clientRect = {
                top: this.anchors[index].getBoundingClientRect().top + window.scrollY,
                bottom: this.anchors[index].getBoundingClientRect().bottom + window.scrollY,
                height: this.anchors[index].getBoundingClientRect().height
            }
        })

        this.items.forEach((element, index) => {
            let elementStyle = window.getComputedStyle(element)

            this.items[index].clientRect = {
                left: element.getBoundingClientRect().left + parseInt(elementStyle.getPropertyValue('padding-left')),
                width: element.getBoundingClientRect().width - parseInt(elementStyle.getPropertyValue('padding-left'))*2
            }

            if (this.items[index].classList.value.indexOf(STATES.ACTIVE) != -1) {
                this.index = index
            }
        })

        this.moveIndicator()
    }

    handleEnter() {
        this.element.classList.add(STATES.PINNED)
    }

    handleLeave() {
        this.element.classList.remove(STATES.PINNED)
    }

    handleClick(event) {
        event.preventDefault()

        let target = document.querySelector(event.target.closest('a').getAttribute('href'))

        if (target) {
            scrollToElement(target)
        }
    }

    switchActive(index) {
        if (this.index == index) {
            return
        }

        this.ref.inner.querySelector(`[href="#${this.active}"]`).classList.remove('is-active')
        this.ref.inner.querySelector(`[href="#${this.anchors[index].id}"]`).classList.add('is-active')

        this.active = this.anchors[index].id
        this.index = index

        this.moveIndicator()
    }

    moveIndicator() {
        this.ref.indicator.style.left = this.items[this.index].clientRect.left + 'px'
        this.ref.indicator.style.width = this.items[this.index].clientRect.width + 'px'
    }
}
